import React, { useMemo } from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { checkForEmptyNotes } from '../../helper/helpersSubModule';
import { applyStylestoCellRenderer } from '../../helper/helperFunctions';
import './CustomNumberRenderer.css'; 
import PropTypes from 'prop-types';


const NumericValue = ({ value, cellStyles }) => {
    let displayValue = value !== undefined ? (value === '' ? value : parseFloat(value)) : '';
    if (!isNaN(displayValue)) {
        return <span className="numeric-value" style={cellStyles}>{displayValue}</span>;
    }
    return null;
};

const NoteIcon = ({ colDef, data, onClickOpenRightDrawer, readOnlyMode }) => {
    const hasNotes = colDef?.field && data?.hasOwnProperty(colDef.field + '_es') && data[colDef.field + '_es'] !== undefined && !checkForEmptyNotes(data[colDef.field + '_es']?.notes);
    
    if (hasNotes) {
        return (
            <ArrowDropDownIcon
                className="note-icon"
                onClick={(e) => { onClickOpenRightDrawer("notes", 0); }}            />
        );
    }
    return null;
};
NoteIcon.propTypes = {
    colDef: PropTypes.object,
    data: PropTypes.object,
    onClickOpenRightDrawer: PropTypes.func,
    readOnlyMode: PropTypes.bool,
};
export const CustomNumberRenderer = ({params}) => {
    const { colDef, data, value } = params;
    const columnName = colDef?.field + "_es";
    const cellFormat = data?.[columnName]?.format || '';

    const cellStyles = useMemo(() => applyStylestoCellRenderer(cellFormat), [cellFormat]); // Still using useMemo for style calculation

    return (
        <div className="number-renderer">
            <NumericValue value={value} cellStyles={cellStyles} />
            <NoteIcon colDef={colDef} data={data} onClickOpenRightDrawer={params?.onClickOpenRightDrawer} readOnlyMode={params.readOnlyMode} />
        </div>
    );
};
CustomNumberRenderer.propTypes = {
    params: PropTypes.shape({
        colDef: PropTypes.object,
        data: PropTypes.object,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        onClickOpenRightDrawer: PropTypes.func,
        readOnlyMode: PropTypes.bool,
    }).isRequired,
};
